import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import { apiRequest } from '../services/api';
import { toast } from 'react-toastify';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
         mobile: ''
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
        setErrors({ ...errors, [e.target.id]: '' });
    };

    const validate = () => {
        let newErrors = {};
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }
        const mobileRegex = /^\+?[0-9]{8,15}$/;
        if (!formData.mobile.trim()) {
            newErrors.mobile = 'Mobile number is required';
        } else if (!mobileRegex.test(formData.mobile.trim())) {
            newErrors.mobile = 'Enter a valid mobile number (with or without country code)';
        }
        if (!formData.subject.trim()) newErrors.subject = 'Subject is required';
        if (!formData.message.trim()) newErrors.message = 'Message is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (validate()) {
            try {
                setLoading(true);
                const res = await apiRequest({
                    url: '/enquiry',
                    method: 'POST',
                    data: formData
                });

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'form_submit',
                    form_type: 'contact',
                    form_location: window.location.pathname,
                    user_name: formData.name   
                });

                toast.success('Enquiry sent successfully!');
                setFormData({ name: '', email: '', subject: '', message: '', mobile: '' });
            } catch (err) {
                console.error('Error sending mail:', err.message);
            } finally {
                setLoading(false);
            }
        }
    };


    return (
        <>
            <PageHeader
                title="Contact Us"
                image="img/about-banner.jpg" // use your own path
                breadcrumbs={[
                    { label: "Contact", active: true },
                ]}
            />

            <div className="container-fluid contact bg-light py-5">
                <div className="container py-5">
                    <div className="mx-auto text-center mb-5" style={{ maxWidth: '900px' }}>
                        <h5 className="section-title px-3">Contact Us</h5>
                        <h1 className="mb-0">Contact For Any Query</h1>
                    </div>
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-4">
                            <div className="bg-white rounded p-4">
                                <div className="text-center mb-4">
                                    <i className="fa fa-map-marker-alt fa-3x text-primary"></i>
                                    <h4 className="text-primary">Address</h4>
                                    <p className="mb-0">
                                        Office No E 69, First Floor, <br /> your own Business center, Al Maskan Building,<br /> Near LuLu Hyper Market - Al Karama,<br /> Dubai
                                    </p>
                                </div>
                                <div className="text-center mb-4">
                                    <i className="fa fa-phone-alt fa-3x text-primary mb-3"></i>
                                    <h4 className="text-primary">Mobile</h4>
                                    <p className="mb-0">+971 52 325 6358</p>
                                </div>
                                <div className="text-center">
                                    <i className="fa fa-envelope-open fa-3x text-primary mb-3"></i>
                                    <h4 className="text-primary">Email</h4>
                                    <p className="mb-0">sales@theholidaybasket.com</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <h3 className="mb-2">Send us a message</h3>
                            <p className="mb-4">
                                Have any questions or need assistance? <br />
                                Feel free to reach out to us, and we’ll get back to you as soon as possible!
                            </p>
                            <form>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" onChange={handleChange} value={formData.name} className={`form-control border-0 ${errors.name ? 'is-invalid' : ''}`} id="name" placeholder="Your Name" />
                                            <label htmlFor="name">Your Name</label>
                                            {errors.name && <div className="text-danger small ms-1 mt-1">{errors.name}</div>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" onChange={handleChange} value={formData.mobile} className={`form-control border-0 ${errors.mobile ? 'is-invalid' : ''}`} id="mobile" placeholder="Your Mobile Number" />
                                            <label htmlFor="mobile">Your Mobile Number</label>
                                            {errors.mobile && <div className="text-danger small ms-1 mt-1">{errors.mobile}</div>}
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-floating">
                                            <input type="email" onChange={handleChange} value={formData.email} className={`form-control border-0 ${errors.email ? 'is-invalid' : ''}`} id="email" placeholder="Your Email" />
                                            <label htmlFor="email">Your Email</label>
                                            {errors.email && <div className="text-danger small ms-1 mt-1">{errors.email}</div>}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-floating">
                                            <input type="text" onChange={handleChange} value={formData.subject} className={`form-control border-0 ${errors.subject ? 'is-invalid' : ''}`} id="subject" placeholder="Subject" />
                                            <label htmlFor="subject">Subject</label>
                                            {errors.subject && <div className="text-danger small ms-1 mt-1">{errors.subject}</div>}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-floating">
                                            <textarea
                                                className={`form-control border-0 ${errors.message ? 'is-invalid' : ''}`}
                                                placeholder="Leave a message here"
                                                onChange={handleChange}
                                                id="message"
                                                style={{ height: '160px' }}
                                                value={formData.message}
                                            ></textarea>
                                            <label htmlFor="message">Message</label>
                                            {errors.message && <div className="text-danger small">{errors.message}</div>}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button className="btn btn-primary w-100 py-3" disabled={loading} onClick={handleSubmit}>
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Please wait...
                                                </>
                                            ) : (
                                                'Send Message'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-12">
                            <div className="rounded">
                                <iframe
                                    className="rounded w-100"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28871.674132230324!2d55.26271007431643!3d25.238296899999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f42da49925515%3A0x2cbd93ae378eda04!2sAl%20Maskan%20%2C%20Karama!5e0!3m2!1sen!2sin!4v1745488925104!5m2!1sen!2sin"
                                    style={{ height: '450px' }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade">

                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Contact;
